var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOverlayBG)?_c('transition',{attrs:{"name":"component-fade"}},[_c('div',{staticClass:"overlay-bg"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }